import { createAsyncThunk } from '@reduxjs/toolkit';
import { RECORD_STATUS } from 'LixaniAPI/enums';
import uuidv4 from 'uuid/v4';
import { selectSelectedProjectInRecord } from '../selectors/records.selectors';
import { postClockInAllowanceRecord } from '../services/clockInAllowanceRecord.service';
import { setOptimisticRecord } from '../actions/records.actions';

export const clockInAllowanceRecord = createAsyncThunk(
  'records/clockInAllowanceRecord',
  async (allowanceType, { getState, dispatch, rejectWithValue }) => {
    const inRecord = selectSelectedProjectInRecord(getState());

    const now = new Date().toISOString();

    const projectId = inRecord.project.id;
    const parentId = inRecord.id;
    const resource =
      inRecord.resource && inRecord.resource.id
        ? inRecord.resource.id
        : undefined;

    const optimisticRecord = {
      id: uuidv4(),
      clockInAt: now,
      project: projectId,
      status: RECORD_STATUS.IN,
      type: allowanceType,
      mirrorUser: inRecord.mirrorUser,
      resource: resource,
      parentRecordId: parentId,
      updatedAt: now,
      createdAt: now,
      user: inRecord.user,
    };

    dispatch(setOptimisticRecord(optimisticRecord));

    try {
      const createdRecord = await postClockInAllowanceRecord(
        projectId,
        parentId,
        optimisticRecord
      );
      return createdRecord;
    } catch (e) {
      return rejectWithValue(optimisticRecord.id);
    }
  }
);
